import { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { motion } from 'framer-motion'
import { CoworkLogo } from '@/components/ui/CoworkLogo'
import { AuthBrandPanel } from '@/components/auth/AuthBrandPanel'
import { VerifyResultCard, type VerifyStatus } from '@/components/auth/EmailVerificationCards'
import { verifyEmail } from '@/services/authService'

export default function VerifyEmailPage() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [status, setStatus] = useState<VerifyStatus>(token ? 'loading' : 'error')
  const [message, setMessage] = useState(token ? '' : 'ลิงก์ยืนยันอีเมลไม่ถูกต้อง')
  const [alreadyVerified, setAlreadyVerified] = useState(false)
  // กัน React StrictMode เรียก effect ซ้ำใน dev
  const requested = useRef(false)

  useEffect(() => {
    if (!token || requested.current) return
    requested.current = true
    verifyEmail(token)
      .then((r) => {
        setAlreadyVerified(r.already_verified)
        setStatus('success')
      })
      .catch((err) => {
        setMessage(err instanceof Error ? err.message : 'ยืนยันอีเมลไม่สำเร็จ')
        setStatus('error')
      })
  }, [token])

  return (
    <div className="flex min-h-screen">
      <AuthBrandPanel />

      <div className="flex w-full flex-col items-center justify-center bg-white px-4 py-10 lg:w-[45%]">
        <div className="mb-8 lg:hidden">
          <CoworkLogo />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="w-full max-w-[440px]"
        >
          <VerifyResultCard status={status} alreadyVerified={alreadyVerified} message={message} />
        </motion.div>
      </div>
    </div>
  )
}
